import { Dialog, DialogTitle, DialogActions, DialogContent } from '@mui/material';
import { Button } from 'atoms/Button';
import { TransitionButton } from 'atoms/TransitionButton';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { useCallback } from 'react';

type LineUnLinkDialogProps = {
  open: boolean;
  onOk: () => Promise<void>;
  onClose: () => void;
};

export const LineUnLinkDialog = (props: LineUnLinkDialogProps) => {
  const { open } = props;
  const { t: tUserEditDelete } = useTranslationWithLang('userEditDelete');
  const handleClickUnlink = useCallback(() => props.onOk(), [props.onOk]);

  return (
    <>
      <Dialog
        open={open}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            color: 'var(--c-text)',
            padding: '20px',
            borderRadius: '10px',
            backgroundColor: 'var(--c-background2)',
            boxShadow: '0 3px 10px rgba(0, 0, 0, 0.2)',
          },
        }}
      >
        <DialogTitle style={{ fontWeight: 'bold', textAlign: 'center' }}>
          {tUserEditDelete('TU006_050')}
        </DialogTitle>
        <DialogContent className="text-center">{tUserEditDelete('TU006_051')}</DialogContent>
        <DialogActions style={{ justifyContent: 'center' }}>
          <TransitionButton
            label={tUserEditDelete('TU006_024')}
            onClick={props.onClose}
            className="mr-2"
          />
          <Button label={tUserEditDelete('TU006_052')} onClick={handleClickUnlink} />
        </DialogActions>
      </Dialog>
    </>
  );
};
